 
const settingsStyles = theme => ({
    pageTitle: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: '10px',
        marginBottom: '20px'
    },
    submitBtn: {
        background: '#1B23ED !important', 
        boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important', 
        borderRadius: '3px !important',  
        width: '122px !important',  
        color: '#FFFFFF !important'
    },
    select: {
        border: '1px solid rgba(0, 0, 0, 0.13)',
        borderRadius: '5px',
        padding: '5px 24px 5px 5px',
        background: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMjYyMTcgOS42OTg4NEwwLjk5NTg4MyAxLjU0MjQyQzAuNTY2MjUyIDAuODc3MDEgMS4wNDM5MyAwIDEuODM1OTkgMEgxMi4zNjg2QzEzLjE2MDYgMCAxMy42MzgzIDAuODc3MDEgMTMuMjA4NyAxLjU0MjQyTDcuOTQyMzggOS42OTg4NEM3LjU0ODQ2IDEwLjMwODkgNi42NTYwOSAxMC4zMDg5IDYuMjYyMTcgOS42OTg4NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPg==") #F7F7F7 no-repeat calc(100% + 16px) !important',
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        backgroundRepeat: 'no-repeat !important',
        backgroundOrigin: 'content-box !important',
        backgroundSize: '1.4ex !important'
    },
        
    icon: {
        width: '16px',
        height: '16px'
    },
    settingsItem: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        borderRadius: '5px', maxWidth: '280px', padding: '10px', display: 'flex', justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px'
    }
});

export default settingsStyles;



// WEBPACK FOOTER //
// ./src/containers/settings/jss/SettingsStyles.js